import { render } from "./WindowsIcon.vue?vue&type=template&id=8ef94e9c"
const script = {}

import exportComponent from "/home/tabelka-front/tabelka.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__